// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__BZTqb","left":"Virtual_left__PhRJm","wrapper":"Virtual_wrapper__KV3yJ"};